import { AuthoringBlockType, ConnectorType, HeaderPositionType, NodeType, PaletteColorType, TextStyleType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class HierarchyDiagramCategory extends BaseCategory {
    get name() {
        return "Hierarchy Diagram";
    }

    get type() {
        return SlideCategories.HIERARCHY_DIAGRAM;
    }

    get icon() {
        return null;
    }

    get description() {
        return "The content describes a central concept with related items radiating outward, or a hub-and-spoke relationship. Use this for showing connections between a central idea and supporting elements, organizational structures, or hierarchical relationships.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Parse the content to identify a central hub concept and its related spoke items. The hub should be the main/central concept, and items should be the connected elements.`;
    }

    getImagePrompt() {
        return false;
    }

    getModelHints() {
        return {
            diagramType: "hub and spoke | hierarchy | organizational structure",
        };
    }

    getPromptSchema(options) {
        return {
            hub: "string for the center hub item (the main/central concept)",
            items: this.getItemListSchema(options),
            conclusion: "an optional short conclusion or takeaway for the slide",
        };
    }

    validateGeneratedModel(model) {
        if (!this.validateArray(model.items)) {
            return false;
        }
        return true;
    }

    getSlideModels(model, options = {}) {
        let models = [
            this.buildHubAndSpoke(model, true, options),
            this.buildHubAndSpoke(model, false, options),
        ];

        return models;
    }

    // buildHubAndSpoke(model) {
    //     let builder = new SlideModelBuilder("hub_and_spoke", model);
    //     builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.LEFT, backgroundColor: "theme" });
    //
    //     // Create hub node
    //     const hubModel = {
    //         id: "hub",
    //         nodeType: NodeType.CIRCLE,
    //         color: PaletteColorType.THEME,
    //         textWidth: 100,
    //         text: model.hub ? {
    //             blocks: [{
    //                 html: model.hub,
    //                 textStyle: TextStyleType.TITLE,
    //                 type: AuthoringBlockType.TEXT,
    //             }]
    //         } : {
    //             blocks: [{
    //                 html: "",
    //                 textStyle: TextStyleType.TITLE,
    //                 type: AuthoringBlockType.TEXT,
    //             }]
    //         }
    //     };
    //
    //     // Create spoke items
    //     const items = model.items.map(item => ({
    //         nodeType: NodeType.TEXT,
    //         text: {
    //             blocks: [
    //                 builder.createBlock(item.title, TextStyleType.TITLE),
    //                 // builder.createBlock(item.description, TextStyleType.BODY),
    //             ]
    //         }
    //     }));
    //
    //     // Create connectors from hub to each spoke
    //     const connectors = {
    //         items: items.map((item, index) => ({
    //             source: "hub",
    //             target: null, // Will be set by the element based on item ids
    //             connectorType: ConnectorType.STRAIGHT,
    //             startDecoration: "none",
    //             endDecoration: "arrow",
    //         }))
    //     };
    //
    //     let primary = {
    //         hub: hubModel,
    //         items: items,
    //         connectors: connectors,
    //         collectionColor: "colorful",
    //         connectorStyle: "hub",
    //         useAlternateRotation: true,
    //         ellipse_size: 1.9
    //     };
    //
    //     builder.createPrimary(primary);
    //
    //     if (model.conclusion) {
    //         builder.createBottomTray(model.conclusion);
    //     }
    //
    //     return builder.model;
    // }

    buildHubAndSpoke(model, showIcons, options = {}) {
        let builder = new SlideModelBuilder("hub_and_spoke", model);
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.LEFT, backgroundColor: "theme" });

        // Create hub node
        const hubModel = {
            id: "hub",
            nodeType: NodeType.CIRCLE,
            color: PaletteColorType.THEME,
        };

        if (model.hub) {
            hubModel.textWidth = 100;
            hubModel.text = {
                blocks: [
                    builder.createBlock(model.hub, TextStyleType.TITLE)
                ]
            };
        }

        // Create spoke items with icons
        const items = model.items.map(item => {
            if (showIcons) {
                return {
                    nodeType: NodeType.CONTENT_AND_TEXT,
                    ...builder.createIcon(item.icon ?? "star"),
                    text: {
                        blocks: [
                            builder.createBlock(item.title, TextStyleType.TITLE),
                        ]
                    }
                };
            } else {
                return {
                    nodeType: NodeType.TEXT,
                    text: {
                        blocks: [
                            builder.createBlock(item.title, TextStyleType.TITLE),
                            builder.createBlock(item.description, TextStyleType.BODY),
                        ]
                    }
                };
            }
        });

        // Create connectors from hub to each spoke
        const connectors = {
            items: items.map((item, index) => ({
                source: "hub",
                target: null, // Will be set by the element based on item ids
                connectorType: ConnectorType.STRAIGHT,
                startDecoration: "none",
                endDecoration: "arrow",
            }))
        };

        let primary = {
            hub: hubModel,
            items: items,
            connectors: connectors,
            collectionColor: "colorful",
            connectorStyle: "hub",
            useAlternateRotation: true,
            ellipse_size: 1.9
        };

        builder.createPrimary(primary);

        if (options.citeSources) {
            builder.createSourcesAttribution(model.sources);
        }

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }

        return builder.model;
    }
}
